import React, { useContext, useRef, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { useDispatch } from "react-redux";
import "react-toastify/dist/ReactToastify.css";

import "./Aside.scss";
import { AppContext } from "../../utils/context";
import gold_arrow from "../../assets/images/gold_arrow.png";
import ConditionalModalInviteFail from "../ConditionalModal/ConditionalModalInviteFail";
import ConditionalModalInviteSucess from "../ConditionalModal/ConditionalModalInviteSucess";
import ConditionalModalBillSucess from "../ConditionalModal/ConditionalModalBillSucess";
import MyVerticallyCenteredModal from "../MyVerticallyCenteredModal";

const Aside = ({ setActiveTab, activeTab, closeNavbar }) => {
  const dispatch = useDispatch();
  const { setMobile } = useContext(AppContext);
  const [modalShow, setModalShow] = useState(false);
  const [failModalShow, setFailModalShow] = useState(false);
  const [failMessage, setFailMessage] = useState("");
  const [successModalShow, setSuccessModalShow] = useState(false);
  const [successModal2Show, setSuccessModal2Show] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const modalRef = useRef();
  const handleResetOutside = () => {
    if (modalRef.current) {
      modalRef.current.handleReset();
    }
  };

  const handleTabChange = (tabId) => {
    if (closeNavbar) {
      closeNavbar();
    }
    if (setActiveTab) {
      setActiveTab(tabId);
    }

    if (activeTab === "v-pills-home") {
      console.log("active home");
    } else {
      console.log("active other");
    }
  };
  return (
    <div className="aside-box">
      <div
        className="nav flex-column nav-pills "
        id="v-pills-tab"
        role="tablist"
        aria-orientation="vertical"
      >
        <h1>My Account</h1>
        <div className="account-section">
          <p className="labelHeading">ACCOUNT</p>
          <NavLink
            to="/home"
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            <h2 className="" onClick={() => handleTabChange("v-pills-home")}>
              Rewards Points
            </h2>
            <span className="navigator_arrow">
              <img src={gold_arrow} alt="" />
            </span>
          </NavLink>
          <NavLink
            to="/rewards-catalogue"
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            <h2
              className=""
              onClick={() => handleTabChange("v-pills-offersHistory")}
            >
              Rewards Catalogue
            </h2>
            <span className="navigator_arrow">
              <img src={gold_arrow} alt="" />
            </span>
          </NavLink>
        </div>
        <div className="account-section">
          <p className="labelHeading">ACTIVITIES</p>
          {/* <NavLink
            to="/friends-family"
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            <h2 onClick={() => handleTabChange("v-pills-family")}>
              Friends & Family
            </h2>
            <span className="navigator_arrow">
              <img src={gold_arrow} alt="" />
            </span>
          </NavLink> */}
          <MyVerticallyCenteredModal
            ref={modalRef}
            show={modalShow}
            onHide={() => setModalShow(false)}
            setModalShow={setModalShow}
            setFailModalShow={setFailModalShow}
            setFailMessage={setFailMessage}
            setSuccessModalShow={setSuccessModalShow}
            setSuccessModal2Show={setSuccessModal2Show}
            setSuccessMessage={setSuccessMessage}
          />
          <h2
            onClick={() => setModalShow(true)}
            className="billUPload desktop_content"
          >
            Bill Upload{" "}
            <span className="navigator_arrow">
              <img src={gold_arrow} alt="" />
            </span>
          </h2>
        </div>
        <div className="account-section" style={{ borderBottom: "none" }}>
          <p className="labelHeading">
            OTHERS{" "}
            <span className="navigator_arrow">
              <img src={gold_arrow} alt="" />
            </span>
          </p>
          <NavLink
            to="/dlf-malls"
            className={({ isActive }) => {
              const urlArr = window.location.href.split("/");
              const pathname = urlArr[urlArr.length - 1];
              return isActive || pathname === "avenueMalls" ? "active" : "";
            }}
          >
            <h2
              className=""
              data-bs-toggle="pill"
              data-bs-target="#v-pills-dlfMalls"
              type="button"
              role="tab"
              aria-controls="v-pills-dlfMalls"
              aria-selected="false"
              onClick={() => handleTabChange("v-pills-dlfMalls")}
            >
              {" "}
              DLF Malls
            </h2>
            <span className="navigator_arrow">
              <img src={gold_arrow} alt="" />
            </span>
          </NavLink>
          {/* <NavLink
            to="/offers"
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            <h2
              className=""
              data-bs-toggle="pill"
              data-bs-target="#v-pills-offers"
              type="button"
              role="tab"
              aria-controls="v-pills-offers"
              aria-selected="false"
              onClick={() => handleTabChange("v-pills-offers")}
            >
              Offers
            </h2>
            <span className="navigator_arrow">
              <img src={gold_arrow} alt="" />
            </span>
          </NavLink> */}
          <NavLink
            to="/tier-history"
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            <h2
              className=""
              data-bs-toggle="pill"
              data-bs-target="#v-pills-tierHistory"
              type="button"
              role="tab"
              aria-controls="v-pills-tierHistory"
              aria-selected="false"
              onClick={() => handleTabChange("v-pills-tierHistory")}
            >
              Tier Benefits
            </h2>
            <span className="navigator_arrow">
              <img src={gold_arrow} alt="" />
            </span>
          </NavLink>

          <NavLink
            to="/faqs"
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            <h2
              className=""
              data-bs-toggle="pill"
              data-bs-target="#v-pills-dlfMalls"
              type="button"
              role="tab"
              aria-controls="v-pills-dlfMalls"
              aria-selected="false"
              onClick={() => handleTabChange("v-pills-dlfMalls")}
            >
              {" "}
              FAQ
            </h2>
            <span className="navigator_arrow">
              <img src={gold_arrow} alt="" />
            </span>
          </NavLink>
          <NavLink
            to="/contact-us"
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            <h2
              className=""
              data-bs-toggle="pill"
              data-bs-target="#v-pills-dlfMalls"
              type="button"
              role="tab"
              aria-controls="v-pills-dlfMalls"
              aria-selected="false"
              onClick={() => handleTabChange("v-pills-dlfMalls")}
            >
              {" "}
              Contact Us
            </h2>
            <span className="navigator_arrow">
              <img src={gold_arrow} alt="" />
            </span>
          </NavLink>
          <NavLink
            to="/feedback"
            className={({ isActive }) =>
              isActive ? "active mobile_content" : "mobile_content"
            }
          >
            <h2
              className=""
              data-bs-toggle="pill"
              data-bs-target="#v-pills-dlfMalls"
              type="button"
              role="tab"
              aria-controls="v-pills-dlfMalls"
              aria-selected="false"
              onClick={() => handleTabChange("v-pills-dlfMalls")}
            >
              {" "}
              FeedBack
            </h2>
            <span className="navigator_arrow">
              <img src={gold_arrow} alt="" />
            </span>
          </NavLink>
          <NavLink
            to="/privacy-policy"
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            <h2
              className=""
              data-bs-toggle="pill"
              data-bs-target="#v-pills-dlfMalls"
              type="button"
              role="tab"
              aria-controls="v-pills-dlfMalls"
              aria-selected="false"
              onClick={() => handleTabChange("v-pills-dlfMalls")}
            >
              {" "}
              Privacy Policy
            </h2>
            <span className="navigator_arrow">
              <img src={gold_arrow} alt="" />
            </span>
          </NavLink>
          <NavLink
            to="/terms"
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            <h2
              className=""
              data-bs-toggle="pill"
              data-bs-target="#v-pills-terms"
              type="button"
              role="tab"
              aria-controls="v-pills-terms"
              aria-selected="false"
              onClick={() => handleTabChange("v-pills-terms")}
            >
              Terms And Conditions
            </h2>
            <span className="navigator_arrow">
              <img src={gold_arrow} alt="" />
            </span>
          </NavLink>
          <NavLink
            to="/delete-account"
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            <h2
              className=""
              data-bs-toggle="pill"
              data-bs-target="#v-pills-terms"
              type="button"
              role="tab"
              aria-controls="v-pills-terms"
              aria-selected="false"
              // onClick={() => handleTabChange("v-pills-terms")}
            >
              Delete Account
            </h2>
            <span className="navigator_arrow">
              <img src={gold_arrow} alt="" />
            </span>
          </NavLink>
          <h2 className="logout">
            <Link
              to="/"
              onClick={() => {
                localStorage.clear();
                setMobile("");
                dispatch({ type: "RESET" }); //calls the root reducer with RESET as action!
              }}
            >
              Log Out
            </Link>
            <span className="navigator_arrow">
              <img src={gold_arrow} alt="" />
            </span>
          </h2>
        </div>
      </div>
      {failModalShow ? (
        <ConditionalModalInviteFail
          show={true}
          onHide={() => {
            setFailModalShow(false);
            setFailMessage("");
            setModalShow(false);
            handleResetOutside();
          }}
          text={failMessage}
        />
      ) : null}
      {successModalShow ? (
        <ConditionalModalInviteSucess
          show={true}
          onHide={() => {
            setSuccessModalShow(false);
            setSuccessMessage("");
            setModalShow(false);
            handleResetOutside();
          }}
          text={successMessage}
        />
      ) : null}
      {successModal2Show ? (
        <ConditionalModalBillSucess
          show={true}
          onHide={() => {
            setSuccessModal2Show(false);
            setSuccessMessage("");
            setModalShow(false);
            handleResetOutside();
          }}
          text={successMessage}
        />
      ) : null}
    </div>
  );
};

export default Aside;
